export default __webpack_public_path__ + "static/media/irbis.196b6f32.png";